module.exports = __webpack_public_path__ + "static/media/nagad-payment-wv.a1100674.svg";